import React from 'react';
import styles from './styles.cssm';

const DottedUnderline = (props) => (
  <div className={`${styles.dottedUnderline} ${props.className}`} />
);

export default DottedUnderline;
